import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'react-toastify';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { user, isAuthenticated, isAdmin } = useAuth();

  if (!isAuthenticated) {
    return null;
  }

  if (requireAdmin && !isAdmin) {
    toast.error('Admin access required');
    return <div>Access Denied</div>;
  }

  return children;
};

export default ProtectedRoute;
